module.exports = __webpack_public_path__ + "img/logo_icon.f9b76512.png";